import Link from 'next/link';

interface IFooterLink {
  text: string;
  link: string;
  id?: string;
}

export const FooterLink = ({ id, text, link }: IFooterLink) => {
  return (
    <Link
      href={link}
      id={id}
      className='md:text-left font-black text-[15px] text-[#4A4A4A]'>
      {text}
    </Link>
  );
};

export const FooterExternal= ({ id, text, link }: IFooterLink) => {
  return (
    <a
      id={id}
      rel="noopener noreferrer"
      target="_blank"
      href={link}
      className="md:text-left font-black text-[15px] text-[#4A4A4A]"
    >
      {text}
    </a>
  );
};